module.exports = __webpack_public_path__ + "static/img/Tim-Kelly.968413d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tim-Kelly.jpg
// module id = 9RkT
// module chunks = 0